import { render } from "./allocation-percentile-v2.html?vue&type=template&id=391c296c&scoped=true&ts=true&external"
import script from "./allocation-percentile-v2.ts?vue&type=script&lang=ts&external"
export * from "./allocation-percentile-v2.ts?vue&type=script&lang=ts&external"

import "./allocation-percentile-v2.scss?vue&type=style&index=0&id=391c296c&scoped=true&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-391c296c"]])

export default __exports__